import { render, staticRenderFns } from "./edit-activity.vue?vue&type=template&id=5ec3f46b&scoped=true&"
import script from "./edit-activity.vue?vue&type=script&lang=js&"
export * from "./edit-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3f46b",
  null
  
)

export default component.exports